import React, {Component} from "react";

export class Contact extends Component {

    render() {
        return (
            <div>
                <div id="contact">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="section-title">
                                    <h2>Get In Touch</h2>
                                        <p>
                                        Have a question or want to connect?
                                        <br />
                                        Email us at{" "}
                                        <a href="mailto:info@alentures.com">info@alentures.com</a>
                                        {" "}— we’ll reply as soon as we can.
                                        </p>
                                </div>
                            </div>

                        <div className="col-md-3 offset-md-1 contact-info">
                            <div className="contact-item">
                                <h3>Contact Info</h3>
                                {/* <p>
                  <span>
                    <i className="fa fa-map-marker"></i> Address
                  </span>
                                    {this.props.data ? this.props.data.address : "loading"}
                                </p> */}
                            </div>
                            <div className="contact-item">
                                <p>
                  <span>
                    <i className="fa fa-envelope-o"></i> Email
                  </span>{" "}
                                    {this.props.data ? this.props.data.email : "loading"}
                                </p>
                            </div>
                        </div>
                        </div>

                        <div className="col-md-12">
                            <div>
                                <div className="social">
                                    <ul>
                                        <li>
                                            <a href={this.props.data ? this.props.data.instagram : "/"}>
                                                <i className="fa fa-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href={this.props.data ? this.props.data.youtube : "/"}>
                                                <i className="fa fa-youtube"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="footer">
                    <div className="container text-center">
                        <p>
                            &copy; 2025 Alentures, LLC. All Right Reserved.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contact;